import React from 'react'
import { Categories, Hero, WorkWithUs, Contact } from '../components'
const HomePage = () => {
  return (
    <main>
      <Hero />
      <Categories />
      <WorkWithUs />
      <Contact />
    </main>
  )
}

export default HomePage
